import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ThemeSwitcherService {
  constructor(@Inject(DOCUMENT) private _document: any) {}

  resetTheme() {
    const inlineStyle = this._document.querySelector(`style#custom-theme`);
    if (inlineStyle) {
      this._document.head.removeChild(inlineStyle);
    }
  }

  setTheme(isLightMode: boolean) {
    this.resetTheme();

    if (isLightMode) {
      this._document.documentElement.classList.add('light');
      this._document.documentElement.classList.remove('dark');
    } else {
      this._document.documentElement.classList.remove('light');
      this._document.documentElement.classList.add('dark');
    }
  }
}
